import React, { useState } from "react";
import "./MainFile.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import Spinner from "../../Spin/Spinner";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  sendEmailOTP,
  updatePassword,
  verifyOtp,
} from "../../../config/LiveApi";

function MainFile() {
  const [newShow, setNewShow] = useState(false);
  const [confShow, setConfShow] = useState(false);
  const [data, setData] = useState({
    newPassword: "",
    confPassword: "",
    otp: "",
  });
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [changePass, setChangePass] = useState(false);
  const token = useSelector((state) => state.userReducer.token);
  const userId = useSelector((state) => state.userReducer.userId);
  let generatedOtp;

  const hasUppercase = /[A-Z]/.test(data.newPassword);
  const hasNumber = /\d/.test(data.newPassword);
  const hasSpecialChar = /[@$!%*?&]/.test(data.newPassword);
  const isMinLength = data.newPassword.length >= 8;

  const isPasswordValid =
    hasUppercase && hasNumber && hasSpecialChar && isMinLength;
  const passwordsMatch =
    data.newPassword === data.confPassword || data.confPassword === "";

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  const hitApi = async (data) => {
    setChangePass(false);
    setData({
      newPassword: "",
      confPassword: "",
      otp: "",
    });

    if (!isPasswordValid || !passwordsMatch || !data.otp) return;
    setIsloading(true);
    try {
      const verifyOtpResponse = await verifyOtp(userId, data.otp);

      if (verifyOtpResponse.status === 200) {
        const response = await updatePassword(token, data);

        if (response.status === 200) {
          toast.success("Successfully Changed Password.");
          setData({ newPassword: "", confPassword: "", otp: "" });
        } else {
          toast.error(response.message);
        }
      } else toast.error("Invalid OTP.");
    } catch (error) {
      toast.error("Error changing password:", error.message);
    }

    setIsloading(false);
  };

  const sendEmail = async () => {
    setChangePass(true);

    const response = await sendEmailOTP(userId);
    generatedOtp = response.data;
  };

  return (
    <div className="main-comp">
      <div>
        <p className="heading-pass">Change Password</p>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="data-card">
          {!changePass && (
            <div className="inp-field">
              <div className="eye-div">
                <p>New Password</p>
                <input
                  type={newShow ? "text" : "password"}
                  name="newPassword"
                  placeholder="New Password"
                  autoComplete="off"
                  value={data.newPassword}
                  onChange={handleInputChange}
                />
                {newShow ? (
                  <FaEye className="eye" onClick={() => setNewShow(false)} />
                ) : (
                  <FaEyeSlash
                    className="eye"
                    onClick={() => setNewShow(true)}
                  />
                )}

                {data.newPassword && !isPasswordValid && (
                  <ul className="password-error-list">
                    {!hasSpecialChar && (
                      <li>
                        Password must contain at least one special character.
                      </li>
                    )}
                    {!(hasNumber && hasUppercase) && (
                      <li>
                        Password must contain at least one number and one
                        capital letter.
                      </li>
                    )}
                    {!isMinLength && (
                      <li>
                        Password length must be at least 8 characters long.
                      </li>
                    )}
                  </ul>
                )}
              </div>

              <div className="eye-div">
                <p>Confirm Password</p>
                <input
                  type={confShow ? "text" : "password"}
                  name="confPassword"
                  placeholder="Confirm Password"
                  autoComplete="off"
                  value={data.confPassword}
                  onChange={handleInputChange}
                />
                {confShow ? (
                  <FaEye className="eye" onClick={() => setConfShow(false)} />
                ) : (
                  <FaEyeSlash
                    className="eye"
                    onClick={() => setConfShow(true)}
                  />
                )}

                {!passwordsMatch && data.confPassword && (
                  <p className="password-error-message">
                    Passwords don't match
                  </p>
                )}
              </div>
            </div>
          )}

          {changePass && (
            <div className="otp-field">
              <p className="email-otp-text">
                An email with the OTP has been sent to your registered email ID.
              </p>
              <input
                type="text"
                name="otp"
                placeholder="Enter OTP"
                autoComplete="off"
                value={data.otp}
                onChange={handleInputChange}
              />
            </div>
          )}

          {!changePass ? (
            <div className="bottom-section">
              <button
                className="view-btn-data"
                onClick={sendEmail}
                disabled={!isPasswordValid || !passwordsMatch}
              >
                Get OTP
              </button>
              <button
                className="view-btn-cancel"
                onClick={() => navigate("/dashboard")}
              >
                Cancel
              </button>
            </div>
          ) : (
            <div className="bottom-section">
              <button
                className="view-btn-data"
                onClick={() => hitApi(data)}
                disabled={!isPasswordValid || !passwordsMatch || !data.otp}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MainFile;
